import React, { useRef } from 'react';
import GuideViewerStepCard from './GuideViewerStepCard';
import { GuideProgress } from '@/types';
import { GuideStep, GuideStepType } from '@/services/apis/guides';
import { motion } from 'framer-motion';

interface GuideSlideViewProps {
  currentStep: GuideStep;
  currentStepIndex: number;
  totalSteps: number;
  progress: GuideProgress | null;
  onStepComplete: (stepIndex: number, forceComplete?: boolean) => void;
  onNext: () => void;
  onPrevious: () => void;
  getStepTranslation: (step: GuideStep) => any;
  guideId: string;
  isSavingComplete?: boolean;
}

const GuideSlideView: React.FC<GuideSlideViewProps> = ({
  currentStep,
  currentStepIndex,
  totalSteps,
  progress,
  onStepComplete,
  onNext,
  onPrevious,
  getStepTranslation,
  guideId,
  isSavingComplete = false,
}) => {
  const isStepCompleted = progress?.completedStepIds.includes(currentStep.id) || false;
  return (
    <div className="md:max-w-3xl 2xl:max-w-5xl m-auto h-100">
      <motion.div
        key={currentStep.id}
        className="min-h-[70vh] flex items-center py-8"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, margin: '-10%' }}
        transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
      >
        <GuideViewerStepCard
          step={currentStep}
          stepIndex={currentStepIndex}
          totalSteps={totalSteps}
          isCompleted={isStepCompleted}
          onComplete={() => onStepComplete(currentStepIndex, currentStep.type === GuideStepType.QUESTION)}
          onNext={onNext}
          onPrevious={onPrevious}
          getStepTranslation={getStepTranslation}
          guideId={guideId}
          progress={progress}
          isSavingComplete={isSavingComplete}
        />
      </motion.div>
    </div>
  );
};

export default GuideSlideView;
